/* One-time scroll unveil for homepage imagery (PDP LAB 19 Sep 2026). ~0.5KB, no dependencies. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const els = document.querySelectorAll('.kn-ranges__media, .kn-editorial__media');
  const io = new IntersectionObserver((entries) => entries.forEach((e) => {
    if (!e.isIntersecting) return;
    e.target.classList.add('is-in');
    io.unobserve(e.target);
  }), { rootMargin: '0px 0px -12% 0px' });
  els.forEach((el) => {
    if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return; // already on screen: leave it still
    el.classList.add('kn-unveil');
    io.observe(el);
  });
})();
